import { render } from "./messageManage.vue?vue&type=template&id=7f044b3c"
import script from "./messageManage.vue?vue&type=script&lang=js"
export * from "./messageManage.vue?vue&type=script&lang=js"
script.render = render

export default script